import React from 'react';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Contact = () => {
  const redirectAfterSubmit =
    typeof window !== 'undefined'
      ? `${window.location.origin}/contacto?sucesso=true`
      : '';

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-[#003d82] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">Contacte-nos</h1>
            <p className="text-xl text-gray-200">
              Estamos aqui para ajudar! Entre em contacto para obter mais informações ou pedir um orçamento.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 -mt-20 relative z-10">
            <div className="bg-white rounded-xl p-6 shadow-xl border-t-4 border-[#f5a623]">
              <div className="w-12 h-12 rounded-lg bg-[#f5a623]/10 flex items-center justify-center mb-4">
                <MapPin className="text-[#003d82]" size={24} />
              </div>
              <h3 className="font-semibold text-[#003d82] mb-2">Morada</h3>
              <p className="text-gray-600 text-sm">
                {companyInfo.address.street}<br />
                {companyInfo.address.lojas}<br />
                {companyInfo.address.postal} {companyInfo.address.city}
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-xl border-t-4 border-[#f5a623]">
              <div className="w-12 h-12 rounded-lg bg-[#f5a623]/10 flex items-center justify-center mb-4">
                <Phone className="text-[#003d82]" size={24} />
              </div>
              <h3 className="font-semibold text-[#003d82] mb-2">Telefone</h3>
              <a
                href={`tel:${companyInfo.phone}`}
                className="text-gray-600 hover:text-[#003d82] transition-colors"
              >
                {companyInfo.phone}
              </a>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-xl border-t-4 border-[#f5a623]">
              <div className="w-12 h-12 rounded-lg bg-[#f5a623]/10 flex items-center justify-center mb-4">
                <Mail className="text-[#003d82]" size={24} />
              </div>
              <h3 className="font-semibold text-[#003d82] mb-2">Email</h3>
              <a
                href={`mailto:${companyInfo.email}`}
                className="text-gray-600 hover:text-[#003d82] transition-colors text-sm break-all"
              >
                {companyInfo.email}
              </a>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-xl border-t-4 border-[#f5a623]">
              <div className="w-12 h-12 rounded-lg bg-[#f5a623]/10 flex items-center justify-center mb-4">
                <Clock className="text-[#003d82]" size={24} />
              </div>
              <h3 className="font-semibold text-[#003d82] mb-2">Horário</h3>
              <p className="text-gray-600 text-sm">
                Segunda a Sexta<br />
                {companyInfo.hours.weekdays}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Form and Map Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div>
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-[#003d82] mb-3">
                  Pedir Orçamento
                </h2>
                <p className="text-gray-600">
                  Preencha o formulário e entraremos em contacto consigo brevemente.
                </p>
              </div>

              <form action="https://api.web3forms.com/submit" method="POST" className="space-y-6">
                <input type="hidden" name="access_key" value="9c4b508e-de26-4298-9abd-4a010161fb57" />
                <input type="hidden" name="subject" value="Novo Pedido de Orçamento - Litoral Norte" />
                {redirectAfterSubmit ? (
                  <input type="hidden" name="redirect" value={redirectAfterSubmit} />
                ) : null}

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                      Nome *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003d82] focus:border-transparent outline-none transition-all"
                      placeholder="O seu nome"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                      Email *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003d82] focus:border-transparent outline-none transition-all"
                      placeholder="seu@email.com"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                      Telefone *
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003d82] focus:border-transparent outline-none transition-all"
                      placeholder="912 345 678"
                    />
                  </div>

                  <div>
                    <label htmlFor="serviceType" className="block text-sm font-semibold text-gray-700 mb-2">
                      Tipo de Serviço *
                    </label>
                    <select
                      id="serviceType"
                      name="serviceType"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003d82] focus:border-transparent outline-none transition-all bg-white"
                    >
                      <option value="">Selecione...</option>
                      <option value="Aluguer Regular">Aluguer Regular</option>
                      <option value="Aluguer Especializado">Aluguer Especializado</option>
                      <option value="Turismo">Turismo</option>
                      <option value="Outro">Outro</option>
                    </select>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="origin" className="block text-sm font-semibold text-gray-700 mb-2">
                      Origem *
                    </label>
                    <input
                      type="text"
                      id="origin"
                      name="origin"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003d82] focus:border-transparent outline-none transition-all"
                      placeholder="Ex: Póvoa de Varzim"
                    />
                  </div>

                  <div>
                    <label htmlFor="destination" className="block text-sm font-semibold text-gray-700 mb-2">
                      Destino *
                    </label>
                    <input
                      type="text"
                      id="destination"
                      name="destination"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003d82] focus:border-transparent outline-none transition-all"
                      placeholder="Ex: Porto"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="schedule" className="block text-sm font-semibold text-gray-700 mb-2">
                      Horário Pretendido *
                    </label>
                    <input
                      type="text"
                      id="schedule"
                      name="schedule"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003d82] focus:border-transparent outline-none transition-all"
                      placeholder="Ex: 10:00 - 18:00"
                    />
                  </div>

                  <div>
                    <label htmlFor="duration" className="block text-sm font-semibold text-gray-700 mb-2">
                      Duração *
                    </label>
                    <input
                      type="text"
                      id="duration"
                      name="duration"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003d82] focus:border-transparent outline-none transition-all"
                      placeholder="Ex: 1 dia, 3 horas"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="passengers" className="block text-sm font-semibold text-gray-700 mb-2">
                    Número de Passageiros *
                  </label>
                  <input
                    type="number"
                    id="passengers"
                    name="passengers"
                    required
                    min="1"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003d82] focus:border-transparent outline-none transition-all"
                    placeholder="Ex: 30"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                    Informação Adicional (Opcional)
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#003d82] focus:border-transparent outline-none transition-all resize-none"
                    placeholder="Informações adicionais sobre o seu pedido..."
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-[#f5a623] text-[#003d82] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#e5a71b] transition-all duration-300 hover:shadow-xl flex items-center justify-center gap-2"
                >
                  <Send size={20} />
                  Enviar Pedido
                </button>

                <p className="text-sm text-gray-500 text-center">
                  * Campos obrigatórios
                </p>
              </form>
            </div>

            {/* Map */}
            <div>
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-[#003d82] mb-3">
                  Visite-nos
                </h2>
                <p className="text-gray-600">
                  Encontre-nos no Centro Comercial Premar, na Póvoa de Varzim.
                </p>
              </div>

              <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                <div className="h-[500px]">
                  <iframe
                    src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3004.8!2d${companyInfo.coordinates.lng}!3d${companyInfo.coordinates.lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDIzJzE2LjQiTiA4wrA0NSczOS43Ilc!5e0!3m2!1spt-PT!2spt!4v1234567890!5m2!1spt-PT!2spt`}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Localização Litoral Norte"
                  />
                </div>
                <div className="p-6 bg-[#003d82] text-white">
                  <h3 className="font-semibold mb-2">Centro Comercial Premar</h3>
                  <p className="text-gray-200 text-sm">
                    {companyInfo.address.street}, {companyInfo.address.lojas}<br />
                    {companyInfo.address.postal} {companyInfo.address.city}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
